
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_battery_voltage",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.Battery voltage')
        },
        value() {
            return this.unitLmsgSensors.battery_voltage?.text//this.$t('Not defined')
        },
        icon() {
            return this.showIcon ? 'sensors__battary_voltage' : false
        }
    },
}
</script>

<style scoped>

</style>